module.exports = "/src/views/player/help/images/post2.jpg";